import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { urlLanguage, useLang } from "@/lib/i18n";

// On localized public pages the URL decides the language (/en/... is English),
// so what visitors see always matches what search engines indexed.
export default function UrlLanguageSync() {
  const { pathname } = useLocation();
  const { lang, setLang } = useLang();
  const fromUrl = urlLanguage(pathname);
  useEffect(() => {
    if (fromUrl && fromUrl !== lang) setLang(fromUrl);
  }, [fromUrl, lang, setLang]);
  return null;
}
